import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import IProfileType from './IProfileType';
import IDroneAvailability from './IDroneAvailability';

class ProfileApi {
    static load(): Promise<any> {
        return new Api().get('/me/profile');
    }

    static loadDroneAvailability(): Promise<IDroneAvailability> {
        return new Api().get('/me/drone-availability');
    }

    static updateDroneAvailability(hasDrone: boolean): Promise<void> {
        return new Api().put('/me/drone-availability', { hasDrone: hasDrone });
    }

    static update(profile: IProfileType): Promise<IProfileType> {
        return new Api().put('/me/profile', profile);
    }

    static uploadProfileImage(image: any) {
        return new Api().postFiles('/me/profile/image', [image]);
    }
}

export default ProfileApi;
